import type { ExternalAfterFixProofClientSafeSummaryV1 } from "@enrein/shared-contracts";
import { EXTERNAL_AFTER_FIX_STATUS_LABELS } from "@enrein/shared-contracts";

export interface ExternalAfterFixProofPanelProps {
  readonly summary: ExternalAfterFixProofClientSafeSummaryV1;
}

export function ExternalAfterFixProofPanel({ summary }: ExternalAfterFixProofPanelProps) {
  return (
    <section className="panel panel--external-proof value-card" aria-label="After-fix proof summary">
      <p className="value-card-eyebrow">Follow-up scan proof</p>
      <h2 className="value-card-headline">{summary.headline}</h2>
      <p className="journey-subtitle">
        This read-only summary compares follow-up scan signals after your agency applied fixes externally.
        Enrein does not edit or control your website.
      </p>

      <div className="external-proof-block">
        <p>
          Fixed: {summary.summaryCounts.fixed} · Still open: {summary.summaryCounts.stillOpen} · Needs proof:{" "}
          {summary.summaryCounts.needsProof}
        </p>
      </div>

      {summary.items.length ? (
        <ul>
          {summary.items.map((item) => (
            <li key={`${item.label}-${item.status}`}>
              <strong>{item.label}</strong> — {EXTERNAL_AFTER_FIX_STATUS_LABELS[item.status]}
              <p>{item.summary}</p>
            </li>
          ))}
        </ul>
      ) : null}

      <details className="external-proof-block">
        <summary>What we do not promise</summary>
        <ul>
          {summary.whatWeDoNotPromise.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </details>
    </section>
  );
}
